// src/components/auth-nav.js

import React from 'react';
import AuthenticationButton from './authentication-button';

const AuthNav = () => (
  <div className="flex flex-col lg:flex-row gap-2 lg:ml-auto">
    <AuthenticationButton />
  </div>
);

export default AuthNav;
